import map from "lodash/map";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalGeneric from "../../Common/ModalGeneric";
import BybetjentCreateModalContent from "../BybetjentForm";
import OpenModalComponent from "./OpenModalComponent";

import {
    addBetjentToTeam,
    getBybetjenter,
    postBybetjenter,
} from "../../../actions/bybetjenterActions";
import { getBybetjentGrupper } from "../../../actions/bybetjentgrupperAction";
import { getBybetjentRoller } from "../../../actions/bybetjentrollerAction";
import { getBybetjentSeksjoner } from "../../../actions/bybetjentseksjonerAction";
import {
    IsValidated,
    onChangeValidation,
} from "../../../utils/validationUtils";

const rules = {
  navn: "required;minLength=3",
  nummer: "required;isDigit",
  mobil: "isDigit;length=8",
  aktivertDato: "isDato;isLessThan=deaktivertDato",
  deaktivertDato: "isDato;isFuture;isLargerThan=aktivertDato",
  epost: "isEmail",
  rolle: "required",
  seksjon: "required",
};

const initState = {
  open: false,
  submitButtonText: "Legg til ny",
  nummer: "",
  team: [],
  seksjon: 0,
  rolle: 0,
  navn: "",
  mobil: "",
  epost: "",
  aktivertDato: new Date().toISOString(),
  deaktivertDato: "",
  validationError: {},
  openDeaktiverConfirm: false,
};

export default function Bybetjent() {
  const dispatch = useDispatch();
  const grupper = useSelector((state) => state.betjentgrupper);
  const roller = useSelector((state) => state.betjentroller);
  const seksjoner = useSelector((state) => state.bybetjenterseksjoner);

  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  useEffect(() => {
    dispatch(getBybetjentGrupper());
    dispatch(getBybetjentRoller());
    dispatch(getBybetjentSeksjoner());
  }, [dispatch]);

  const closeModal = () => setState(initState);
  const openModal = () => update({ open: true });

  const isValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const betjentroller = () =>
    map(roller, (i) => Object.assign([], { id: i.kode, navn: i.beskrivelse }));

  const generateTeamPayload = (s) => ({
    nummer: s.nummer,
    navn: s.navn,
    team: s.team.map((i) => i.id),
    seksjon: s.seksjon,
    rolle: s.rolle,
    mobil: s.mobil,
    epost: s.epost,
    aktivertDato: s.aktivertDato || null,
    deaktivertDato: s.deaktivertDato || null,
  });

  const handlePost = async () => {
    const payload = generateTeamPayload(state);
    const betjent = await dispatch(postBybetjenter(payload));
    await Promise.all(
      map(payload.team, (item) => dispatch(addBetjentToTeam(betjent.id, item)))
    );
    await dispatch(getBybetjenter());
    closeModal();
  };

  const saveAndClose = async () => {
    if (isValid() && !state.deaktivertDato) {
      await handlePost();
    } else if (isValid() && state.deaktivertDato) {
      update({ open: false, openDeaktiverConfirm: true });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = name === "nummer" ? parseInt(value) : value;
    const draft = { ...state, [name]: parsedValue };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  const mappedRoller = betjentroller();

  return (
    <React.Fragment>
      <ModalGeneric
        modalTitle="Legg til ny bypatrulje ansatt"
        open={state.open}
        closeModal={closeModal}
        openModal={openModal}
        OpenModalComponent={OpenModalComponent}
        submit={saveAndClose}
        submitButtonText={state.submitButtonText}
      >
        <BybetjentCreateModalContent
          teamList={grupper}
          seksjoner={seksjoner}
          roller={mappedRoller}
          rolle={state.rolle}
          seksjon={state.seksjon}
          nummer={state.nummer}
          team={state.team}
          navn={state.navn}
          mobil={state.mobil}
          epost={state.epost}
          aktivertDato={state.aktivertDato}
          deaktivertDato={state.deaktivertDato}
          validationError={state.validationError}
          handleChange={handleChange}
        />
      </ModalGeneric>
      <ModalGeneric
        modalTitle="Deaktiver bruker"
        open={state.openDeaktiverConfirm}
        closeModal={() => update({ openDeaktiverConfirm: false, open: true })}
        submit={handlePost}
        submitButtonText={state.submitButtonText}
      >
        <p>Vil du deaktivere betjent {state.navn}?</p>
      </ModalGeneric>
    </React.Fragment>
  );
}
